<div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
  <kendo-grid [kendoGridBinding]="ProjectWorkflowStatusList" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [pageable]="true" id="grvEDMMemberList">
      <ng-template kendoPagerTemplate>
          <div class="k-pager-left">
              <kendo-pager-info></kendo-pager-info>
          </div>
          <div class="k-pager-right">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-input></kendo-pager-input>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
          </div>
      </ng-template>
      <ng-template kendoGridToolbarTemplate>
          <div class="k-grid-toolbar-content d-flex">
              <div class="flex-grow-1 mat-panel-headerbar"></div>
              <div class="pagination-container" style="width:35%;"><span class="eip-mr-15">Business Group:</span>
                  <div style="width:73%;">
                      <form [formGroup]="businessGroupForm" autocomplete="off">
                          <edms-autocomplete [data]="businessGroups" [form]="businessGroupForm" controlName="businessGroup" textField="group_Name" label="Business Group" error="Please select business group" (optionSelected)="selectedOrganization($event)"></edms-autocomplete>
                      </form>
                  </div>
              </div>
              <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
              </div>
              <div class="pagination-container">
                  <p id="lblShowDetails">Show</p>
                  <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                  </kendo-pager-page-sizes>
                  <span>Items</span>
              </div>
              <div class="divider-container d-none d-md-block" id="imgDivider">
                  <span></span>
              </div>
              <div class="icons-container">
                  <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                  <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">

                      <div class="icon-wrap" (click)="toggleFilter()">
                          <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                          <span class="list-icon-name">Filter</span>
                      </div>
                      <div class="icon-wrap">

                          <i class="fa fa-cog" title="Settings" aria-hidden="true"></i>
                          <span class="list-icon-name">Grid Settings</span>
                      </div>
                      <div class="icon-wrap" (click)="toggleFullscreen()">
                          <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                          <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                      </div>
                  </div>
                  <div class="divider-container"><span></span></div>
                  <i class="fa fa-plus-circle icon-my-10" title="Add Member" aria-hidden="true" (click)="addEdit()"></i>
              </div>
          </div>
      </ng-template>
      <kendo-grid-column title="Sl.No." filterable="false" width="60">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{rowIndex+1}}
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Business Group" field="businessGroup" width="200">
      </kendo-grid-column>
      <kendo-grid-column title="Status Description" field="statusDescription" width="150">
      </kendo-grid-column>
      <kendo-grid-column title="Status Type" field="statusTypeDesc" width="150">
      </kendo-grid-column>
      <kendo-grid-column title="Project Status Desc" field="projectStatusDesc" width="200">
      </kendo-grid-column>
      <kendo-grid-column title="S-Curve Status Desc" field="sCurveStatusDesc" width="200">
      </kendo-grid-column>
      <kendo-grid-column title="Status Order" field="status_Order" width="200">
      </kendo-grid-column>
      <kendo-grid-column title="Created By" field="created_By" width="100">
      </kendo-grid-column>
      <kendo-grid-column title="Created On" field="created_On" width="100">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{dataItem.created_On | date:'dd-MMM-yyyy'}}
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Modified By" field="modified_By" width="150">
      </kendo-grid-column>
      <kendo-grid-column title="Modified On" field="modified_On" width="100">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              {{dataItem.modified_On | date:'dd-MMM-yyyy'}}
          </ng-template>
      </kendo-grid-column>
      <kendo-grid-column title="Action" width="80" class="text-center">
          <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
              <i class="fa fa-pencil icon-my-10" (click)="addEdit(dataItem)" aria-hidden="true"  title="Edit" id="btnEDMEdit"></i>
          </ng-template>
      </kendo-grid-column>
  </kendo-grid>
</div>